<template>
  <div class="wb-sidebar-menu"
       ref="menuContainer"
       v-on:scroll="scrollComputeHandler()">
    <SidebarCategoriesScroll :direction="'up'"
                             :width="'336px'"
                             v-show="showTopScroll"
                             v-on:click="scrollByClick(-1)"/>

    <div class="wb-sidebar-menu-list" v-for="value in subcategories">
      <div class="wb-el-color-tooltip" v-if="value.name==='Аксессуары'">
        <SVGWarning/>
        <div class="wb-el-color-tooltip-text">
          Аксессуары не отображаются на конструкции, они будут просто добавлены в ваш заказ
        </div>
      </div>
      <div class="wb-el-color-tooltip" v-if="value.name==='Новинки'">
        <SVGWarning/>
        <div class="wb-el-color-tooltip-text">
          Новинки не отображаются на конструкции, они будут просто добавлены в ваш заказ
        </div>
      </div>
      <SidebarMenuLabel :text="value.name"/>
      <div class="wb-sidebar-menu-group">
        <div v-for="item of getItems(value.items)" :key="item.id">
          <div class="wb-c-grey-line-h"></div>
          <SidebarMenuItem :data="item"
                           :categories="value.name"
                           :component-type="getComponentType(value.name)"
                           @dragstartCustom="value.name === 'Аксессуары'? onDragStart($event) : onDragStart($event)"/>
        </div>
      </div>
    </div>
    <SidebarCategoriesScroll :direction="'down'"
                             :width="'336px'"
                             v-show="showBotScroll"
                             v-on:click.stop="scrollByClick(1)"/>
  </div>
</template>

<script>
import SidebarCategoriesScroll from '@/UI/Components/ComponentsSidebarCategories/SidebarCategoriesScroll.vue';
import SidebarMenuLabel from '@/UI/Components/ComponentsSidebarMenu/SidebarMenuLabel.vue';
import SidebarCategoriesItem from '@/UI/Components/ComponentsSidebarCategories/SidebarCategoriesItem.vue';
import SidebarMenuItem from '@/UI/Components/ComponentsSidebarMenu/SidebarMenuItem.vue';
import { demoMenuItems } from '@/Constants/demoData';
import { useStoreData } from '@/Store/storeData';
import { useConfigurationStore } from '@/Store/storeConfiguration';
import SVGWarning from '@/UI/Components/SVG/SVGWarning.vue';

export default {
    name: 'TheSidebarMenu',
    components: {
      SVGWarning,
        SidebarMenuItem,
        SidebarCategoriesItem,
        SidebarMenuLabel,
        SidebarCategoriesScroll,
    },
    setup() {
        const storeData = useStoreData();
        const storeConfiguration = useConfigurationStore();
        return {
            storeData,
            storeConfiguration,
        };
    },
    data() {
        return {
            items: demoMenuItems,
            scrollHeight: 0,
            scrollTop: 0,
            containerHeight: 0,
            scrollStep: 113,
        };
    },
    computed: {
        subcategories() {
            let dataOut;
            // TODO refactoring
            if (this.storeData.getActiveCategoriesSection === 1) {
                dataOut = this.storeData.getSubcategoriesOfActiveConstructionCategory;
                if (!dataOut) {
                    dataOut = this.storeData.getActiveConstructionCategoryData;
                }
                return dataOut;
            } else {
                dataOut = this.storeData.getSubcategoriesOfActiveCategory;
                if (!dataOut) {
                    dataOut = this.storeData.getActiveCategoryData;
                }
                return dataOut.sort((category1,category2)=>category1.sort-category2.sort);
            }
        },
        showTopScroll() {
            return this.scrollTop > 0;
        },
        showBotScroll() {
            return this.scrollHeight > this.containerHeight + this.scrollTop;
        },
    },
    methods: {
        getItems(idArr) {
            if (this.storeData.getActiveCategoriesSection === 1) {
                return this.storeData.getConstructionItemsByIdArr(idArr);
            } else {
                let allItems = this.storeData.getItemsByIdArr(idArr);
                let wardrobeColor = this.storeConfiguration.getWardrobeBaseColor;
                allItems.sort((item1,item2)=>item1.sort-item2.sort);
                return allItems.filter((item) => item.color.hex === wardrobeColor.replace('#', '') || item.color.hex === '');
            }
        },
        onDragStart(itemEvent) {
          // const dragImage = itemEvent.img.cloneNode(true);
          // dragImage.width = 40;
          // dragImage.height = 40;
          // dragImage.style = 'width: 40px; height: 40px;';
          // itemEvent.e.dataTransfer.setDragImage(dragImage, 10, 10);
          itemEvent.e.dataTransfer.setDragImage(document.createElement('span'), 10, 10);
          this.setDnDElement(itemEvent.data);
        },
        setDnDElement(data) {
          this.storeData.setDnDElement(data);
        },
        scrollComputeHandler() {
            this.scrollHeight = this.getScrollHeight();
            this.scrollTop = this.getScrollTop();
            this.containerHeight = this.getContainerHeight();
        },
        getScrollHeight() {
            return this.$refs.menuContainer?.scrollHeight;
        },
        getScrollTop() {
            return this.$refs.menuContainer?.scrollTop;
        },
        getContainerHeight() {
            return this.$refs.menuContainer?.clientHeight;
        },
        getComponentType(name){
          switch (name){
            case 'Новинки':
              // return '6';
            case 'Аксессуары':
              return '2';
            case 'Окна и двери':
              return '5';
            default:
              return '1';
          }
        },
        scrollByClick(direction) {
            // TODO add smooth animation
            this.$refs.menuContainer.scrollTop = this.$refs.menuContainer.scrollTop + direction * this.scrollStep;
        },
    },
    mounted() {
        this.scrollComputeHandler();
        window.addEventListener('resize', this.scrollComputeHandler);
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.scrollComputeHandler);
    },
};
</script>

<style scoped lang="scss">
@import "CSS/colors.scss";
@import "CSS/common.scss";

.wb-el-color-tooltip {
  display: grid;
  grid-template-columns: max-content auto;
  grid-column-gap: 16px;
  color: $green1;
  margin-bottom: 30px;
}

.wb-el-color-tooltip-text {
  color: $darkBlue;
  @include font-t1;
  @include wb-c-flex-center-start;
  text-align: left;
}

.wb-sidebar-menu {
  width: 336px;
  height: 100%;
  box-sizing: border-box;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: $white;


  -ms-overflow-style: none;
  scrollbar-width: none;
}

.wb-sidebar-menu::-webkit-scrollbar {
  display: none;
}

.wb-sidebar-menu-list {
  padding: 24px 16px;
  display: flex;
  flex-direction: column;
}

.wb-sidebar-menu-group {
  display: flex;
  flex-direction: column;
  height: max-content;
  width: 100%;
  box-sizing: border-box;
}
</style>
